export default __webpack_public_path__ + "static/media/newlogo.d3ffffb4.png";